import { Component, ElementRef, Input, OnInit, ViewChild, AfterViewChecked } from '@angular/core';
import { ITableConfig } from 'projects/common/src/app/interfaces/table/table-config';
import { ITableDataParams } from 'projects/common/src/app/interfaces/table/table-data-params';
import { ITableExtraParams } from 'projects/common/src/app/interfaces/table/table-extra-params';
import { ITableHeaderParams } from 'projects/common/src/app/interfaces/table/table-header-params';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { TableConfigService } from 'projects/common/src/app/services/table/table-config.service';
import { GoogleAnalyticsService } from 'src/app/modules/core/services/google/google-analytics.service';
import { IStatisticsProductionData, ITraductionModal } from 'src/app/modules/dashboard/interfaces/sp/productionbymachine';
import { isThisTypeNode } from 'typescript';

@Component({
  selector: 'app-statistics-production',
  templateUrl: './statistics-production.component.html',
  styleUrls: ['./statistics-production.component.scss'],
})
export class StatisticsProductionComponent implements OnInit, AfterViewChecked {
  @Input()
  public data: IStatisticsProductionData;
  @Input()
  public machineObjCode: string;
  public tableConfig: ITableConfig[];
  public titles = [];

  public traductionModal: ITraductionModal;

  @ViewChild('scroll', { static: true })
  public scrollContainer: ElementRef;
  public disableShadowBottom = false;
  public disableShadowTopBottom = true;
  public disableShadowTop = true;
  public widthScrollContainer = 0;

  constructor(
    private tableConfigService: TableConfigService,
    private languageService: LanguageService,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) {}

  /**
   * On init component
   */
  public ngOnInit(): void {
    this.translateTables(this.machineObjCode);
    this.tableConfig = [];

    if (this.data && this.data.productionByOperatorPercentage.length) {
      this.setTableConfig(this.data.productionByOperatorPercentage, ['operator']);

      this.titles = [...this.titles, this.languageService.message('production-by-operator-percentage')];
    }

    if (this.data && this.data.productionByMachinePercentage.length) {
      this.setTableConfig(this.data.productionByMachinePercentage, ['machineName']);

      this.titles = [...this.titles, this.languageService.message('machines-used-shift')];
    }
    if (this.data && this.data.productionByStatus.length) {
      this.setTableConfig(this.data.productionByStatus);

      this.titles = [...this.titles, this.languageService.message('production-by-status')];
    }
    if (this.data && this.data.productionByEndZone.length && this.machineObjCode !== 'JMB') {
      this.setTableConfig(this.data.productionByEndZone);

      this.titles = [...this.titles, this.languageService.message('production-by-endzone')];
    }
    let customEvent = {};
    if ('drillingsmts' in this.data) {
      customEvent = {
        tab_modal: 'production-by-machine_statistics',
      };
    } else {
      customEvent = {
        tab_modal: 'production-by-operator_statistics',
      };
    }
    this.googleAnalyticsService.sendCustomEvent('modal', customEvent);
  }

  /**
   * After View checked
   */
  public ngAfterViewChecked(): void {
    const element = this.scrollContainer.nativeElement;
    if (element.scrollHeight > element.clientHeight) {
      this.widthScrollContainer = this.scrollContainer.nativeElement.getBoundingClientRect().width - 10;
    }
  }

  private translateTables(machineType: string): void {
    switch (machineType) {
      case 'LHD':
        this.traductionModal = {
          stadistics: {
            headerFirstTable: this.languageService.message('shelves'),
            headerSecondTable: this.languageService.message('shelves'),
          },
        };
        break;
      case 'JMB':
        this.traductionModal = {
          stadistics: {
            headerFirstTable: this.languageService.message('drillings_mts'),
          },
        };
        break;
      case 'TRU':
        this.traductionModal = {
          stadistics: {
            headerFirstTable: this.languageService.message('loops'),
            headerSecondTable: this.languageService.message('loops'),
          },
        };
        break;

      default:
        break;
    }
  }

  /**
   * Function to set a table by config
   */
  private setTableConfig(tableData: any[], largeColumns = null): void {
    const replaceColumnName = [
      { prevName: 'machineName', newName: 'machineType' },
      { prevName: 'loops', newName: this.traductionModal.stadistics.headerFirstTable },
      { prevName: 'shelves', newName: this.traductionModal.stadistics.headerSecondTable },
      { prevName: 'drillingmts', newName: this.traductionModal.stadistics.headerFirstTable },
    ];

    const headerParams: ITableHeaderParams = {
      data: tableData,
      largeColumns,
      replaceColumnName,
    };
    const datasetParams: ITableDataParams = {
      tableData,
      largeColumns,
    };
    const header = this.tableConfigService.setHeaderConfig(headerParams);
    const dataset = this.tableConfigService.setDatasetConfig(datasetParams);

    const extraParams: ITableExtraParams = {
      noDataMsg: 'm019',
      disableFooter: true,
      minimalRows: tableData.length,
      quantityPerPage: tableData.length,
    };

    setTimeout(() => this.tableConfig.push({ header, dataset, extraParams }), 0);
  }

  /**
   * On scroll component
   */
  public onScroll(): void {
    const element = this.scrollContainer.nativeElement;
    const atBottom = Math.floor(element.scrollHeight - element.scrollTop) === element.clientHeight;
    const atTop = element.scrollTop === 0;

    if (atTop && !atBottom) {
      this.disableShadowBottom = false;
      this.disableShadowTop = true;
      this.disableShadowTopBottom = true;
    } else if (!atTop && !atBottom) {
      this.disableShadowBottom = true;
      this.disableShadowTop = true;
      this.disableShadowTopBottom = false;
    } else if (!atTop && atBottom) {
      this.disableShadowBottom = true;
      this.disableShadowTop = false;
      this.disableShadowTopBottom = true;
    }
  }
}
